// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+lEYS","main-image":"Header_main-image__KcRp-"};